import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Auth } from 'store/auth/actions';
import { isAuthenicatedSelector, pendingSelector } from 'store/auth/selectors';
import { RegisterForm } from './components/RegisterForm';

import './style.scss';

const RegisterPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector(isAuthenicatedSelector);
  const pending = useSelector(pendingSelector);

  useEffect(() => {
    dispatch(Auth.authErrorAction(null));
    dispatch(Auth.getPriceTypesList());
    dispatch(Auth.getUserTypeList());
  }, [dispatch]);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  const handleLogin = () => {
    history.push('/login');
  };

  const handleSubmit = async (data) => {
    dispatch(Auth.signUp(data));
    history.push('/check-email-registration');
  };

  return (
    <div className="login-content">
      <RegisterForm pending={pending} title="Регистрация" onSubmit={handleSubmit} />
      <div className="login-footer">
        Уже есть аккаунт?
        <div className="login-link" onClick={handleLogin}>
          Войдите
        </div>
      </div>
    </div>
  );
};

export { RegisterPage };
